import React from 'react'

import { useEffect, useCallback, useState, useMemo } from 'sb-hooks'


const useSteps = ({ steps, withScroll }) => {
  const stepNames = useMemo(() => Object.keys(steps), [ steps ])

  const [ step, setStep ] = useState(stepNames[0])

  const stepIndex = stepNames.indexOf(step)

  const goNextStep = useCallback(() => {
    const nextStep = stepNames[stepIndex + 1]

    setStep(nextStep)
  }, [ step, stepIndex ])

  useEffect(() => {
    if (withScroll) {
      window.scrollTo(0, 0)
    }
  }, [ step, withScroll ])

  return {
    step,
    stepIndex,
    goNextStep,
  }
}


export default useSteps
